// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseAnybound() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>anyBOUND</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>エンタープライズ</span>
            <span>ブロックチェーン事業開発</span>
            <span>共創プロジェクト</span>
          </div>
          <h1 className="cd-title">
            希少な旅行体験をブロックチェーンで流通させる。株式会社JTBとの共創プロジェクト「anyBOUND」
          </h1>
          <p className="cd-client">株式会社JTB</p>
          <div className="cd-img">
            <img
              src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
              alt=""
            />
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                世界中の富裕層が、希少な体験コンテンツへの情報取得・手配に課題を抱えていた。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                LEAPSは企画・開発・マーケティングの全フェーズにわたる共創パートナーとして参画しました。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>2025年12月にメインサイトを公開。</p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              anyBOUNDは、株式会社JTBとLEAPSが共同開発した富裕層向けの旅行体験プラットフォームです。世界中の希少なコンテンツをトークン化し、暗号通貨決済やNFT販売を通じてグローバルに流通させる、これまでにない旅行購入体験の実現を目指しています。
            </p>
            <p>
              LEAPSは事業の構想段階から参画し、プロジェクト企画、Webアプリケーションおよびスマートコントラクト開発実装、暗号資産決済の導入、さらにマーケティング全般を担当。JTBが持つ国内外354拠点のネットワークと、LEAPSのブロックチェーン技術を掛け合わせることで、旅行業界に新たな価値流通の仕組みを構築しました。
            </p>
          </section>
          <section className="cd-sec">
            <h2>解決すべき課題</h2>
            <h4 className="cd-sub">市場における課題</h4>
            <ul className="cd-list">
              <li>
                世界中の富裕層が、希少な体験コンテンツへの情報取得・手配に課題を抱えていた
              </li>
              <li>
                従来の法定通貨決済では、クロスボーダーなオンライン販売に摩擦が生じていた
              </li>
              <li>
                訪日インバウンド市場における富裕層セグメントへのアプローチ手法が確立されていなかった
              </li>
            </ul>
            <h4 className="cd-sub">事業化における課題</h4>
            <ul className="cd-list">
              <li>
                ブロックチェーンを活用した具体的な事業案を立案・提案できるパートナーがいなかった
              </li>
              <li>
                ユースケース設計から実装・運用まで一貫して担える企業が存在しなかった
              </li>
              <li>
                概念検討に留まり、実際のサービスとして事業化するフェーズに進めていなかった
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSが提供したソリューション</h2>
            <p>
              LEAPSは企画・開発・マーケティングの全フェーズにわたる共創パートナーとして参画しました。事業構想の段階からJTBとともにユースケースを設計し、ブロックチェーン技術の実装だけでなく、Web3コミュニティを活用した市場開拓まで一気通貫で担いました。
            </p>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">企画・事業設計</p>
                <h3 className="cd-ptitle">構想段階からの事業共創</h3>
                <p>
                  ユースケース設計・収益モデルの検討・ターゲット定義など、事業の骨格づくりからJTBチームと共同で推進。技術的実現性を常に検証しながら企画を具体化しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">開発・実装</p>
                <h3 className="cd-ptitle">ブロックチェーン基盤の構築</h3>
                <p>
                  暗号通貨（ETH・USDCなど）による決済の開発、旅行体験の権利をNFTとして販売する仕組みの実装、サイト全体の開発・運用まで一貫して対応しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">マーケティング</p>
                <h3 className="cd-ptitle">Web3エコシステムへのリーチ</h3>
                <p>
                  自社のネットワークを活かしたコミュニティ連携、グローバルな富裕層ユーザーへのアプローチ、NFTコンテンツの企画・開発・販売まで携わっています。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>プロジェクトの成果と展望</h2>
            <p>
              2025年12月にメインサイトを公開。世界中の暗号資産保有者および富裕層ユーザーへの販売を開始しました。今後は旅行体験にとどまらず、酒樽の権利、不動産共同所有権、アートなど希少な現物資産のコンテンツの領域へ展開予定です。
            </p>
          </section>
        </div>
      </section>
      <section className="cd-sec">
        <h2>プロジェクトの成果と展望</h2>
        <p>
          2025年12月にメインサイトを公開。世界中の暗号資産保有者および富裕層ユーザーへの販売を開始しました。今後は旅行体験にとどまらず、酒樽の権利、不動産共同所有権、アートなど希少な現物資産のコンテンツの領域へ展開予定です。
        </p>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/hikky">
              <div className="case-img is-cover">
                <span className="cover-en">METAVERSE NFT</span>
                <span className="cover-ja">メタバース × NFT</span>
              </div>
              <p className="case-meta">メタバース事業会社</p>
              <h3>メタバース霊園の土地と遺品を、NFTで受け継げる仕組みに</h3>
              <div className="case-tags">
                <span>メタバース・エンタメ</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
